import { atom } from 'jotai';
import { TaskSortDirection } from '../api/created/tasks.ts';
import { PatientBasicsDto } from '../api/generated/model';

export enum TaskFilter {
  ALL = 'ALL',
  JOURNAL = 'JOURNAL',
  COMPLIANCE_OVERDUE = 'COMPLIANCE_OVERDUE',
  APPOINTMENT = 'APPOINTMENT',
  TEST_RESULT_INCOMPLETE = 'TEST_RESULT_INCOMPLETE',
  WAITING_PERIOD_OVER = 'WAITING_PERIOD_OVER',
}

export const taskFilterAtom = atom<TaskFilter>(TaskFilter.ALL);
export const taskSelectedPatientFilterAtom = atom<PatientBasicsDto | null>(null);
export const taskIncludeCompletedAtom = atom(false);
export const taskDueDateFilterAtom = atom('');
export const taskAssignedEmployeeIdAtom = atom<string | null>(null);
export const taskSortDirAtom = atom<TaskSortDirection>('asc');

export enum TaskAssignedToPreset {
  ALL = 'ALL',
  SELF = 'SELF',
  NONE = 'NONE',
  SPECIFIC = 'SPECIFIC',
}

export const taskAssignedToPresetAtom = atom<TaskAssignedToPreset>(TaskAssignedToPreset.ALL);
